export const COLOR_BAR_CONFIG = {
  curvature: {
    bar: ["AbsNormal", "RelFine", "RelMedium"],
    style: ["standard", "style1", "style2", "style3", "style4", "style5"],
    stepUnit: { D: [0, 0.25, 0.5], mm: [0, 0.05, 0.1] },
    num: [31, 61]
  },
  elevation: {
    bar: ["AbsNormal", "RelFine", "RelMedium"],
    style: ["standard", "style1", "style2", "style5"],
    stepUnit: { μm: [2.5, 5, 10] },
    num: [31, 61]
  },
  heightf: {
    bar: ["AbsNormal"],
    style: ["standard", "style1", "style2", "style5"],
    stepUnit: { mm: [0.05] },
    num: [31, 61]
  },
  tfsq: {
    bar: ["AbsNormal"],
    style: ["standard", "style1", "style2"],
    stepUnit: { μm: [0.017] },
    num: [31, 61]
  },
  rgp: {
    bar: ["AbsNormal"],
    style: ["standard", "fluorescence"],
    stepUnit: { μm: [1.6666666666666667, 150], D: [1.6666666666666667, 150] },
    num: [61]
  }
};



// WEBPACK FOOTER //
// ./src/topography/shared/colorBar-config.js